<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1136838" style="color: #82a339"><b>SMOKED TROUT PÂTÉ</b></p>
<p class="ext" id="d7e1137338"><b><i>This smoky spread is easily prepared in a food processor.</i></b></p>
<p class="h4" id="d7e1138038" style="color: #496210"><b>Prep: 25 minutes</b></p>
<p class="ul" id="d7e1138538">3 whole smoked trout (1¼ pounds total)</p>
<p class="ul" id="d7e1139638">1 container (8 ounces) whipped cream cheese</p>
<p class="ul" id="d7e1139938">¼ cup low-fat mayonnaise dressing</p>
<p class="ul" id="d7e1140938">3 tablespoons fresh lemon juice</p>
<p class="ul" id="d7e1141238">⅛ teaspoon ground black pepper</p>
<p class="ul" id="d7e1142138">1 tablespoon finely chopped fresh chives <br/> or green onion <br/> cucumber slices and assorted crackers</p>
<p class="pub" id="d7e1143338" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Cut head and tail from each trout; discard along with skin and bones. In food processor with knife blade attached, puree trout, cream cheese, mayonnaise dressing, lemon juice, and pepper until smooth.</p>
<p class="pub" id="d7e1145038"><span style="color: #c15b49"><b>2.</b></span> Spoon trout mixture into medium bowl; stir in chives. Cover and refrigerate up to overnight if not serving right away. Before serving, let stand 15 minutes at room temperature to soften. Serve with cucumber slices and crackers. Makes about 3 cups.</p>
<p class="ntx" id="d7e1147338">Each tablespoon: About 32 calories, 2g protein, 1g carbohydrate, 2g total fat (1g saturated), 7mg cholesterol, 101mg sodium.</p>
<div class="side"><p class="sidebarh3" id="d7e1148338" style="color: #8A4117"><b>WHAT ELSE CAN IT DO? <br/> EGG SLICER</b></p>
<p class="ser"><img alt="9781618371621_0038_001.jpg" src="Images/9781618371621_0038_001.jpg" style="max-width:100%;"/></p>
<p class="sidebartx1" id="d7e1149538">Making precise slices of softer, smaller foods is a snap, literally, with this tool designed to hold slippery, hard-cooked eggs in its cradle as the wires cut through. (Cleanup is just as speedy—use a kitchen brush and warm, soapy water.) It can:</p>
<p class="sidebartx1" id="d7e1152338"><b>• </b>Quick-slice soft fruits and vegetables such as peeled kiwis, hulled strawberries, white or cremini mush-rooms, and pitted olives.</p>
<p class="sidebartx1" id="d7e1153738"><b>• </b>Create perfect rounds from soft cheeses, like fresh mozzarella balls and goat cheese.</p>
<p class="sidebartx1" id="d7e1154738"><b>• </b>Make even pats from a stick of butter.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c26_r1.vue?697c3027